import React, { useMemo } from 'react';
import clsx from 'clsx';

import type { CustomerServiceDeviceInfoState } from '@/sites/op7/hooks/useCustomerServiceDeviceInfo';

const ALL_ROWS: { key: keyof CustomerServiceDeviceInfoState; label: string }[] = [
  { key: 'phoneModel', label: '手机型号' },
  { key: 'phoneOs', label: '手机系统' },
  { key: 'loginIp', label: '登录IP' },
  { key: 'loginPort', label: '登录端口' },
  { key: 'osName', label: '操作系统' },
  { key: 'browser', label: '浏览器名称' },
  { key: 'currentTime', label: '当前时间' },
];

export interface CustomerServiceDeviceInfoPanelProps {
  data: CustomerServiceDeviceInfoState;
  className?: string;
  /** H5（true）展示手机型号与手机系统；PC（false）不展示 */
  isMobile?: boolean;
}

const CustomerServiceDeviceInfoPanel: React.FC<CustomerServiceDeviceInfoPanelProps> = ({
  data,
  className,
  isMobile = true,
}) => {
  const rows = useMemo(() => {
    if (isMobile) return ALL_ROWS;
    return ALL_ROWS.filter((r) => r.key !== 'phoneModel' && r.key !== 'phoneOs');
  }, [isMobile]);

  return (
    <div
      className={clsx(
        'flex min-h-0 flex-1 flex-col gap-12px overflow-y-auto rounded-16px bg-[var(--Background-700)] p-0',
        className,
      )}
    >
      <div
        className={clsx(
          'flex w-full max-w-[376px] flex-col self-center overflow-hidden rounded-12px',
          'bg-[var(--Background-300)]',
        )}
      >
        {rows.map((row, index) => (
          <React.Fragment key={row.key}>
            <div
              className={clsx(
                'flex h-40px w-full items-center justify-between px-16px py-10px',
                'text-14px leading-20px whitespace-nowrap',
              )}
            >
              <span className="shrink-0 font-400 text-[var(--Text-Main-10)]">{row.label}</span>
              <span
                className={clsx(
                  'min-w-0 max-w-[70%] whitespace-normal text-right font-400 text-[var(--Text-700)]',
                )}
                title={String(data[row.key])}
              >
                {data[row.key]}
              </span>
            </div>
            {index < rows.length - 1 && <div className="mx-16px h-[0.5px] bg-[var(--Line-100)]" />}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default CustomerServiceDeviceInfoPanel;
